import React from "react";
import Modal from "../atoms/Modal";
import { OrderUseContext } from "../../context/AdminDashboard/OrderContext";
import SelectModal from "../atoms/SelectModal";
import InputGroup from "../atoms/InputGroup";
import BtnModal from "../atoms/BtnModal";
const EditeOrderModal = ({
  doneEdit,
  showModal,
  closeModal,
  modaldata,
  codeval,
  status,
  onchangeselect,
  onchangeInput,
  readOnly,
  disabled
}) => {
  let statuses = [
    { value: "در حال برسی", label: "در حال برسی" },
    { value: "تحویل پست شده", label: "تحویل پست شده" },
    { value: "جدید", label: "جدید" },
  ];

  return (
    <>
      {showModal ? (
        <div>
          <Modal
            title={"تغییر کلمه عبور “V-AAQ01ih2210003”"}
            closeModal={closeModal}>
            <div className="flex flex-col w-379 gap-5">
              <SelectModal
                iconName={"search-status"}
                label={"وضعیت سفارش"}
                values={statuses}
                defaultO={!status? modaldata.status:status}
                wbox="326px"
                onchange={onchangeselect}
              />
              <InputGroup
                placeholder="2346846845135121"
                label={"کد پیگیری سرویس ارسال"}
                val={codeval}
                iconName={"box-search"}
                onchange={onchangeInput}
                id={"code"}
                readOnly={readOnly}
                disabled={disabled}
              />
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end pt-5.5">
              <BtnModal text={"ثبت تغییرات"} accept={doneEdit} />
            </div>
          </Modal>
        </div>
      ) : null}
    </>
  );
};

export default EditeOrderModal;
